import React from "react"
import _ from "lodash"
import moment from 'moment'
import { isValidDate } from 'data/lib/dates'
import { localizeNum } from 'data/lib/numbers'

const VacantLeaseupDisplay = (props: {rowData: {}, field: string}) => {
  const vacantLeaseup = _.get(props.rowData, props.field);
  let display:string|null = null
  if (vacantLeaseup && vacantLeaseup.state !== 'basic'){
    display = `${vacantLeaseup.state.charAt(0).toUpperCase() + vacantLeaseup.state.slice(1)}`
  } else if (vacantLeaseup){
    if (vacantLeaseup['beginDate'] && isValidDate(vacantLeaseup['beginDate'])) {
      display = `${moment(vacantLeaseup['beginDate']).format('MM/YYYY')}`
    } else if (!_.isNil(vacantLeaseup['beginDate'])) {
      display = `${vacantLeaseup['beginDate']}`
    }
    if (vacantLeaseup['leaseupMos']) display += ` | ${localizeNum(vacantLeaseup['leaseupMos'])}`
  } else {
    display = '–'
  }

  return (
    <span>{display}</span>
  )
}

export default VacantLeaseupDisplay
